import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'pdf',

  type : 'module',
  
  label: 'PDF',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-file-pdf-box',
  }
}